import { useDocumentTitle } from '@/hooks/common';

export const NotFoundPage = () => {
  useDocumentTitle('Not Found');
  return <>404 - Not found</>;
};
